import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useNfurecolectadoVSmetaestablecida from "../../../hooks/administrador/general/useNfurecolectadoVSmetaestablecida";
import { getNfurecolectadoVSmetaestablecida } from "../../../utils/administrador/chart_nfu_recolectado_VS_meta_establecida";
import '../../../styles/administrador.css';

const NfurecolectadoVSmetaestablecida = ({ year, mes,token, idAdministrador }) => {
  const chartRef = useRef(null);
  const data = useNfurecolectadoVSmetaestablecida(year, mes,token, idAdministrador);

  useEffect(() => {
    if (Array.isArray(data) && data.length && chartRef.current) {
    if (data.length && chartRef.current) {
      const chartDom = chartRef.current;
      let myChart = echarts.init(chartRef.current);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const updateChart = () => {
        myChart.setOption(getNfurecolectadoVSmetaestablecida(data));
        myChart.resize();
      };
      updateChart();
  
      window.addEventListener("resize", updateChart);
      return () => {
        window.removeEventListener("resize", updateChart);
        myChart.dispose();
      };
    }
  }
  }, [data]);

  return <div className="grafica" ref={chartRef}></div>;
};

export default NfurecolectadoVSmetaestablecida;